import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { safeLocalStorage } from "@/lib/safeStorage";
import { fetchWithTimeout } from "@/lib/supabaseFetch";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// auth.storage uses safeLocalStorage so iOS Safari contexts that
// throw SecurityError on raw `localStorage` access (private mode,
// partitioned storage, in-app browsers) fall back to in-memory
// instead of crashing this module at load. Session won't persist
// across reloads in the degraded case — but the app boots.
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: safeLocalStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
    timeout: 30000,
  },
  // Every request this client makes gets a bounded lifetime — see the
  // policy table in lib/supabaseFetch.ts. A dead connection becomes an
  // error the UI can act on (BackendUnreachable, a toast, a retry)
  // instead of a spinner that never resolves.
  global: {
    fetch: fetchWithTimeout,
  },
});
